export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string) { super(message); }
}

const cookie = (name: string) => document.cookie.split("; ").find((entry) => entry.startsWith(`${name}=`))?.split("=").slice(1).join("=");

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  if (!navigator.onLine && !["GET", "HEAD"].includes(init.method ?? "GET")) throw new ApiError(503, "offline", "Reconnect before submitting an action");
  const headers = new Headers(init.headers);
  if (init.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const csrf = cookie("taskcraft_csrf");
  if (csrf && !["GET", "HEAD"].includes(init.method ?? "GET")) headers.set("X-CSRF-Token", decodeURIComponent(csrf));
  const response = await fetch(`/api${path}`, { ...init, headers, credentials: "include" });
  const data = await response.json().catch(() => ({})) as Record<string, unknown>;
  if (!response.ok) throw new ApiError(response.status, String(data.error ?? "request_failed"), String(data.message ?? data.error ?? "Request failed"));
  return data as T;
}
